/**
 * Permission Repository Implementation
 * Implements the PermissionRepository interface
 * Coordinates between API calls and mappers
 */

import { PermissionRepository } from "../../domain/repositories/PermissionRepository";
import { PermissionsMap } from "../../domain/entities/PermissionEntity";
import { getMyPermissions } from "../api/permissionsApi";
import { PermissionMapper } from "../mappers/PermissionMapper";
import { PermissionResponseDTO } from "../models/PermissionDTOs";

export class PermissionRepositoryImpl implements PermissionRepository {
  async getMyPermissions(): Promise<PermissionsMap> {
    const response = (await getMyPermissions()) as PermissionResponseDTO;
    return PermissionMapper.toPermissionEntity(response);
  }
}
